// [Unleash] コメントの…メニューの固定（fixed）配置を計算する。
//
// 本家はメニューを…ボタン基準の絶対配置で出すため、ボタンが iframe の端や中央寄りに
// あると左右どちらかで見切れる（クラストグルでは iframe 縁に揃えられない）。
// そこで iframe viewport 基準の fixed 配置とし、
//   - 右辺を iframe の右縁（margin 分の余白）に揃える
//   - 上辺を…ボタンの y 座標（top）に揃えて下方向へ展開（右下展開）
//   - 下が足りなければ…ボタン下端にメニュー下端を合わせて上方向へ展開（右上展開）
//   - それでも収まらなければ上端 margin でクランプ
// する。

type Rect = {top: number; bottom: number};
type Size = {height: number};
type Viewport = {width: number; height: number};

export type ContextMenuPositionInput = {
    trigger: Rect;
    menu: Size;
    viewport: Viewport;
    margin?: number;
};

export function computeContextMenuPosition({
    trigger,
    menu,
    viewport,
    margin = 8
}: ContextMenuPositionInput): {top: number; right: number} {
    // 既定は…ボタンの上端に揃えて下方向へ展開
    let top = trigger.top;

    // 下が画面外にはみ出すなら、…ボタン下端にメニュー下端を合わせて上方向へ展開
    if (top + menu.height > viewport.height - margin) {
        top = trigger.bottom - menu.height;
    }

    // 上方向でも収まらない場合は上端 margin でクランプ
    if (top < margin) {
        top = margin;
    }

    return {top, right: margin};
}
